import React from 'react';
import DataInterpretationSEO from '@/components/DataInterpretationSEO';

export interface GeneralChartProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  isNeedHidden?: boolean;
  seoInfo?: React.ReactNode;
  dataEleGroup?: string;
}

const GeneralChart = (props: GeneralChartProps) => {
  const { title, children, seoInfo, isNeedHidden = true, dataEleGroup } = props;

  return (
    <div className="mb-8 px-6 py-10 rounded-lg bg-white/60 tablet:mb-12 tablet:px-10 tablet:py-6">
      <div className="chart-header mb-3 tablet:mb-5">
        <h2 className="font-semibold text-2xl text-black">{title}</h2>
        {seoInfo && (
          <DataInterpretationSEO
            lineClamp="line-clamp-5 tablet:line-clamp-3"
            className="font-normal text-opacity-85"
            dataEleGroup={dataEleGroup}
          >
            {seoInfo}
          </DataInterpretationSEO>
        )}
      </div>
      <div className={isNeedHidden ? 'overflow-auto' : ''}>{children}</div>
    </div>
  );
};

export default GeneralChart;
